export { COACH_BRAND_COLORS, DESCRIPT_COLORS, BRAND_COLORS } from './constants/brand-colors';
export { DAILY_GOALS_COLORS } from './constants/daily-goals-colors';
export { VIDEO_PLAYER_COLORS } from './constants/video-player';
export { ENTERPRISE_PROGRAM_COLORS } from './constants/enterprise-program';
